/**
 * Audit Export Page - Generate Audit Packages
 */
import React from 'react';
import { Package, Download } from 'lucide-react';
import { Card } from '../components/ui-custom/ComplianceUI';

export default function AuditPage() {
  return (
    <div className="audit-page">
      <div className="page-header">
        <h1>Audit Export</h1>
        <p>Generate audit-ready evidence packages</p>
      </div>
      <Card className="empty-state">
        <Package size={48} color="#6b7280" />
        <h3>Ready for Export</h3>
        <p>Export comprehensive audit packages organized by TSC category.</p>
        <button className="btn-primary">
          <Download size={16} /> Export Audit Package
        </button>
      </Card>
    </div>
  );
}
